var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 79,
    viewBox: "0 0 78 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 88"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 13",
    cx: 38.8243,
    cy: 39.4729,
    rx: 38.8243,
    ry: 38.8243,
    fill: "#007EBB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 55.0002H48.8086V42.7516C48.8086 39.3934 47.5326 37.5167 44.8745 37.5167C41.9829 37.5167 40.4722 39.4697 40.4722 42.7516V55.0002H33.5417V31.6668H40.4722V34.8098C40.4722 34.8098 42.556 30.954 47.5075 30.954C52.4567 30.954 56 33.9763 56 40.227V55.0002ZM25.2736 28.6115C22.9129 28.6115 21 26.6836 21 24.3059C21 21.9281 22.9129 20.0002 25.2736 20.0002C27.6343 20.0002 29.5461 21.9281 29.5461 24.3059C29.5461 26.6836 27.6343 28.6115 25.2736 28.6115ZM21.695 55.0002H28.9217V31.6668H21.695V55.0002Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1d832c0daf336194259066660a2f4c3e.svg";
export { ForwardRef as ReactComponent };